import React, { useMemo } from 'react';
import { useThemeLanguage } from '../context/ThemeLanguageContext';
import { getTranslation } from '../translations';
import { buildLandingCtaWhatsAppUrl } from '../utils/buildLandingCtaWhatsAppUrl';
import { LANDING_CPM_NIS } from '../config/pricingFactors';
import './LandingPricingCta.css';

function LandingPricingCta({
  cpm = LANDING_CPM_NIS,
  title,
  subtitle,
  whatsappPreamble,
  compareCpm,
  savingsText,
  sectionClassName = '',
  cardClassName = '',
  id = 'pricing-cta',
}) {
  const { language } = useThemeLanguage();
  const t = (key) => getTranslation(language, 'landing', key);
  const isRtl = language === 'he' || language === 'ar';

  const ctaHref = useMemo(() => {
    const tr = (key) => getTranslation(language, 'landing', key);
    return buildLandingCtaWhatsAppUrl(tr, {
      cpm,
      preamble: whatsappPreamble,
    });
  }, [language, cpm, whatsappPreamble]);

  const sectionClasses = ['landing-pricing-cta', sectionClassName].filter(Boolean).join(' ');
  const cardClasses = ['landing-pricing-cta-card', cardClassName].filter(Boolean).join(' ');

  return (
    <section id={id} className={sectionClasses} dir={isRtl ? 'rtl' : 'ltr'}>
      <div className="landing-pricing-cta-inner">
        <header className="landing-pricing-cta-header">
          <h2 className="landing-pricing-cta-title">{title ?? t('pricingCtaTitle')}</h2>
          <p className="landing-pricing-cta-subtitle">{subtitle ?? t('pricingCtaSubtitle')}</p>
        </header>

        <div className={cardClasses} aria-live="polite">
          {compareCpm != null && (
            <p className="landing-pricing-cta-compare">
              מחיר רגיל:{' '}
              <span className="landing-pricing-cta-strike">₪{compareCpm} CPM</span>
            </p>
          )}
          <div className="landing-pricing-cta-rate">
            <span className="landing-pricing-cta-shekel">₪</span>
            <span className="landing-pricing-cta-amount">{cpm}</span>
            <span className="landing-pricing-cta-unit">{t('pricingCtaCpmUnit')}</span>
          </div>
          <p className="landing-pricing-cta-per">{t('pricingCtaPerThousand')}</p>
          {savingsText && <p className="landing-pricing-cta-savings">{savingsText}</p>}

          <a
            href={ctaHref}
            className="landing-pricing-cta-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('ctaStart')}
          </a>
        </div>
      </div>
    </section>
  );
}

export default LandingPricingCta;
